module.exports = __webpack_public_path__ + "img/R04_05.fd2ee51f.svg";